import React, { Component } from "react";
import { Alert, Container, Spinner } from "reactstrap";

import {
    estraiGettone, scambiaGettone, sessioneEsistente, chiudiSessioneEmbed,
    installaCheckAuthEmbed, chiediIngressoFresco, dentroIframe
} from "./embedSession";

/**
 * IL GUSCIO delle pagine embed: niente header, niente sidebar, solo il contenuto.
 *
 * Fa quattro cose, nell'ordine:
 *   1. consuma il gettone `?t=` (o riusa la sessione esistente, se la pagina viene ricaricata)
 *   2. installa il gestore di scadenza da-iframe (postMessage al genitore, mai il login)
 *   3. CONFINA LA NAVIGAZIONE: un click su qualunque link interno viene fermato qui.
 *      Restano vivi solo tel:, mailto: e i link che aprono una scheda NUOVA (target=_blank,
 *      es. il collegamento alla riunione delle lezioni gratuite) — quelli non portano
 *      l'iframe da nessuna parte.
 *   4. monta il contenuto (children) solo quando la sessione c'e' davvero.
 *
 * ┌─ PERCHE' IL BLOCCO STA SUL CLICK E NON SUL ROUTER ───────────────────────────────────┐
 * │                                                                                      │
 * │ Le uscite di queste pagine sono di due tipi: <Link> del router (navigazione SPA) e   │
 * │ <a href> grezzi (ricaricano tutta la pagina). Un blocco sul router prenderebbe solo  │
 * │ i primi. Ma ENTRAMBI sono <a> nel DOM al momento del click: intercettare il click    │
 * │ in capture, prima che chiunque lo veda, li ferma tutti e due con una regola sola.    │
 * └──────────────────────────────────────────────────────────────────────────────────────┘
 */
class EmbedShell extends Component {

    constructor(props) {
        super(props);
        this.state = {
            fase: "avvio",    // avvio | pronta | scaduta | errore
            messaggio: null
        };
    }

    /**
     * Non c'e' (piu') una sessione utilizzabile.
     *
     * ⚠️ Dentro l'iframe si chiede un ingresso fresco a chi ci incorpora e si mostra lo
     * spinner: il giro dura un istante e l'utente non se ne accorge. In una scheda
     * dedicata (il pulsante "apri in una nuova scheda" di ATOM) NON c'e' nessuno che
     * risponda: lo stesso spinner girerebbe per sempre. Li' si dice cosa fare.
     */
    nonAutenticata = () => {
        // Il gettone che avevamo non vale piu': si butta, altrimenti un ricaricamento
        // lo ritroverebbe e ripartirebbe da capo con lo stesso rifiuto.
        chiudiSessioneEmbed();

        if (dentroIframe()) {
            this.setState({ fase: "scaduta" });
            chiediIngressoFresco();
        } else {
            this.setState({
                fase: "errore",
                messaggio: "La sessione e' scaduta. Chiudi questa scheda e riapri la pagina dal gestionale."
            });
        }
    };

    componentDidMount() {
        // La scadenza in corsa (una chiamata delle tabelle risponde UNAUTHORIZED).
        installaCheckAuthEmbed(this.nonAutenticata);

        const gettone = estraiGettone();

        if (gettone) {
            scambiaGettone(gettone)
                .then(() => this.setState({ fase: "pronta" }))
                .catch((j) => {
                    if (j && j.status === "EMBED_NO_STORAGE") {
                        // Senza storage non c'e' dove tenere il gettone, e ogni chiamata
                        // delle tabelle partirebbe senza.
                        this.setState({
                            fase: "errore",
                            messaggio: "Il browser blocca la memoria locale dentro questa pagina. " +
                                "Apri la pagina in una scheda dedicata."
                        });
                        return;
                    }
                    // Gettone scaduto o gia' speso (doppio caricamento, iframe ricaricato
                    // dal browser): si chiede un ingresso fresco.
                    this.nonAutenticata();
                });
            return;
        }

        // Nessun gettone nell'indirizzo: o la pagina e' stata ricaricata dopo uno scambio
        // andato a buon fine (c'e' la sessione), o siamo arrivati qui a mani vuote.
        if (sessioneEsistente()) {
            this.setState({ fase: "pronta" });
        } else {
            this.nonAutenticata();
        }
    }

    /**
     * Il confinamento. In CAPTURE: si decide prima che React o il router vedano il click.
     */
    gestisciClick = (e) => {
        const anchor = e.target && e.target.closest ? e.target.closest("a") : null;
        if (!anchor) return;

        const href = anchor.getAttribute("href") || "";

        // Contatti: aprono il telefono o la posta, non navigano.
        if (href.startsWith("tel:") || href.startsWith("mailto:")) return;

        // Scheda nuova: l'iframe resta dov'e'. E' il caso del collegamento alla riunione.
        if (anchor.getAttribute("target") === "_blank") return;

        // Tutto il resto e' navigazione interna al gestionale: qui dentro non si naviga.
        e.preventDefault();
        e.stopPropagation();
    };

    render() {
        const { fase, messaggio } = this.state;

        return (
            <div onClickCapture={this.gestisciClick} style={{ minHeight: "100vh", background: "var(--vz-body-bg, #f3f3f9)" }}>
                <Container fluid className="p-3">
                    {fase === "avvio" ? (
                        <div className="d-flex align-items-center justify-content-center" style={{ minHeight: "60vh" }}>
                            <Spinner color="primary" />
                        </div>
                    ) : null}

                    {fase === "scaduta" ? (
                        <div className="d-flex flex-column align-items-center justify-content-center text-center" style={{ minHeight: "60vh" }}>
                            <Spinner color="primary" className="mb-3" />
                            <p className="text-muted mb-0">Ricollegamento in corso…</p>
                        </div>
                    ) : null}

                    {fase === "errore" ? (
                        <Alert color="danger" className="mt-3">{messaggio}</Alert>
                    ) : null}

                    {fase === "pronta" ? (
                        <React.Fragment>
                            {this.props.titolo ? <h5 className="mb-3">{this.props.titolo}</h5> : null}
                            {this.props.children}
                        </React.Fragment>
                    ) : null}
                </Container>
            </div>
        );
    }
}

export default EmbedShell;
